import React, { useState } from "react";
import { Formik, Form, Field, FormikHelpers } from "formik";
import * as Yup from "yup";
import cx from "classnames";
import { useHistory } from "react-router-dom";
import { Alert, Spinner } from "reactstrap";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";

// images
import logo from "../../assets/images/logo.jpeg";
import banner from "../../assets/images/banner.jpeg";

// styles
import styles from "./LoginPage.module.scss";
import { IUserRequestModel } from "../../interfaces/user";
import { loginUser } from "../../redux/actions/authentication/authentication";

//config
import { API_INTEGRATION_ID } from "../../config";
import { notifyError } from "../../config/toastNotification";
import apis from "../../api/apis";
import { APIResponseType } from "../../config/enumApiResponseTypes";

const LoginPage = (): JSX.Element => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [faliedLogin, setFailedLogin] = useState("");
  const [invalidLogin, setInvalidLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const initialValues: IUserRequestModel = {
    Username: "",
    Password: "",
    RequestId: API_INTEGRATION_ID,
    IntegrationId: API_INTEGRATION_ID,
    ApiKey: "",
    RequestingUser: 0,
    Schema: "",
    ValidationMessages: [],
    IsApprovedStatus: 0,
    IsActive: 0,
    RequestingId: "",
    UID: {
      CompanyKey: 0,
      LocationKey: 0,
      UserKey: 0,
      EnvironmentName: "",
      IsUrbanPiper:false,
    },
    EnvironmentName: "",
  };

  //handle submit login form
  const submitForm = async (
    values: IUserRequestModel,
    actions: FormikHelpers<IUserRequestModel>
  ): Promise<void> => {
    values.IntegrationId = API_INTEGRATION_ID;
    values.RequestId = API_INTEGRATION_ID;
    //values.UID.EnvironmentName = values.EnvironmentName;
    //console.log(values);
    //const response = dispatch(loginUser(values));
    //console.log(response);
    try {
      setInvalidLogin(false);
      setFailedLogin("");
      setIsLoading(true);
      if (await dispatch(loginUser(values))) {
        setInvalidLogin(false);
        actions.resetForm();
        history.push("/orders");
        setIsLoading(false);
      } else {
        const response = await apis.Users.validateLogin(values);
        if (
          response.ResponseType === APIResponseType.Failed ||
          response.ResponseType === APIResponseType.InvalidLogin
        ) {
          setFailedLogin(response.ErrorMessages[0]);
        }
        //setInvalidLogin(true);
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
      setInvalidLogin(false);
      //notifyError();
      console.log(e);
    }
  };

  const loginSchema = Yup.object().shape({
    Username: Yup.string().required(),
    Password: Yup.string().required(),
  });

  if (localStorage.getItem("User_AccessToken")) {
    history.push("/orders");
  }

  return (
    <div className={styles.main_wrapper}>
      <img src={logo} alt="Blue Lotus Logo" className={styles.company_logo} />

      <div className={styles.login_form_wrapper}>
        {faliedLogin !== "" && (
          <Alert id={styles.invalid_login_alert} color="danger">
            {faliedLogin}
          </Alert>
        )}
        {invalidLogin && (
          <Alert id={styles.invalid_login_alert} color="danger">
            You have entered an invalid username or password
          </Alert>
        )}
        {isLoading && (
          <Spinner
            className={styles.loading_spinner}
            children=""
            type="grow"
            color="primary"
          />
        )}

        <Formik
          initialValues={initialValues}
          onSubmit={submitForm}
          validationSchema={loginSchema}
        >
          {({ errors, touched }) => (
            <Form>
              <div className={styles.input_group}>
                <Field
                  name="Username"
                  type="text"
                  placeholder="User name"
                  className={cx(
                    styles.input_field,
                    errors.Username && touched.Username && styles.input_error
                  )}
                />
              </div>
              <div className={styles.input_group}>
                <Field
                  name="Password"
                  type="password"
                  placeholder="Password"
                  className={cx(
                    styles.input_field,
                    errors.Password && touched.Password && styles.input_error
                  )}
                />
              </div>
              <div className={styles.input_group}>
                <Field
                  name="EnvironmentName"
                  type="text"
                  placeholder="Environment Name"
                  className={cx(styles.input_field)}
                />
              </div>
              <button type="submit" className={styles.form_submit_btn}>
                Login
              </button>
            </Form>
          )}
        </Formik>
      </div>

      <img
        src={banner}
        alt="Blue Lotus X Banner"
        className={styles.company_banner}
      />
      <ToastContainer />
    </div>
  );
};

export default LoginPage;
